import {
  Component,
  inject,
  linkedSignal,
  model,
  resource,
  Signal,
} from '@angular/core';
import { rxResource, toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Align, PageInfo } from '../components/common/types';
import { ColumnDefinition } from '../components/data-grid/types/colum-definition.type';
import { ModalService } from '../services/modal/modal.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-res-page',
  template: '',
  standalone: true,
})
export abstract class ResourceAdapter<T> {
  readonly router = inject(Router);
  readonly modalService = inject(ModalService);

  seacrhOptions = linkedSignal(() => ({
    pageNo: this.page(),
    pageSize: this.pageSize(),
    query: this.query(),
    orderBy: this.orderBy(),
    align: this.align(),
  }));
  searchOptions$ = toObservable(this.seacrhOptions);

  response = rxResource<T, any>({
    loader: ({ request }) => this.fetchItems(request),
    request: () => this.seacrhOptions(),
  });

  page = model(1);
  pageSize = model(10);
  query = model('');
  orderBy = model('createdAt');
  align = model<Align>('desc');

  abstract items: Signal<any[]>;
  abstract pageInfo: Signal<PageInfo | undefined>;
  abstract fetchItems(request: any): Observable<T>;
  abstract columns: ColumnDefinition[];
}
